<template>
    <div id="settingsprofileinfopage">
        <div class="top-actions">
            <ui5-button @click="$router.push('/settings')">
                {{ trans('pages.settings_profileinfo.back_to_settings') }}
            </ui5-button>
        </div>

        <div id="profile-groups-list">
            <div class="leftcolumn">
                <profile-group-list
                    :title="trans('pages.settings_profileinfo.groups')"
                    endpoint="/profile/groups/"
                    :add-action="addProfileGroup" />

                <profile-group-list
                    :title="trans('pages.settings_profileinfo.subgroups')"
                    endpoint="/profile/subgroups/"
                    :add-action="addProfileSubgroup" />

                <profile-group-list
                    :title="trans('pages.settings_profileinfo.stock_groups')"
                    endpoint="/profile/stockgroups/"
                    :add-action="addProfileStockgroup" />
            </div>
        </div>
    </div>
</template>
<script>
import ProfileGroupList from '../components/profileGroups/ProfileGroupList';
import localization from '../mixins/localization';

export default {
    components: {
        ProfileGroupList,
    },
    mixins: [localization],
    methods: {
        addProfileGroup() {
            this.$router.push('/addProfileGroup/0');
        },
        addProfileSubgroup() {
            this.$router.push('/addProfileGroup/1');
        },
        addProfileStockgroup() {
            this.$router.push('/addProfileGroup/2');
        },
    },
};
</script>
